import { axios } from '../utilities';
import { PAGINATION } from '../../../shared/constants';

const getUpgradeRequests = (
  filters,
  { pageIndex, pageSize } = { pageIndex: PAGINATION.pageIndex, pageSize: PAGINATION.pageSize },
  sortBy = null,
) => axios.get(
  '/api/upgrades',
  {
    params: { filters, pagination: { pageIndex, pageSize }, sortBy },
  },
);

const getUpgradeRequestsForExcel = (filters, sortBy = null) => axios.get(
  '/api/upgrades/excel',
  { params: { filters, sortBy } },
);

export default {
  getUpgradeRequests,
  getUpgradeRequestsForExcel,
};
